var $b61510478bc0e6f6$exports = {};
$b61510478bc0e6f6$exports = {
    "Clear search": `Obri\u{161}i pretragu`
};


export {$b61510478bc0e6f6$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
